import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { QRCodeSVG } from "qrcode.react";
import GenericCard from "components/UI/GenericCard/GenericCard";
import { useSelector } from "react-redux";
import { Button } from "antd";
import {
  apiCreateTelegramLinkUrl,
  apiUnlinkTelegramAccount,
} from "api/apiUser";

const LinkTelegramAccount = () => {
  const hasTelegramLinked = useSelector((state) => state.main.user.telegramId);
  // one-time link from the backend; it expires, so it can be regenerated
  const [link, setLink] = useState(null);
  const [isExpired, setIsExpired] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const createLink = async () => {
    setIsLoading(true);
    try {
      setLink(await apiCreateTelegramLinkUrl());
      setIsExpired(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!hasTelegramLinked) createLink();
  }, [hasTelegramLinked]);

  useEffect(() => {
    if (!link) return undefined;
    const timer = setTimeout(
      () => setIsExpired(true),
      link.expiresInSeconds * 1000,
    );
    return () => clearTimeout(timer);
  }, [link]);

  const onUnlinkTelegram = async () => {
    setIsLoading(true);
    await apiUnlinkTelegramAccount();
    setIsLoading(false);
  };

  return (
    <GenericCard
      title={
        <span className={hasTelegramLinked ? "green" : ""}>
          Link Telegram account
        </span>
      }
    >
      <div style={{ paddingBlockEnd: 10 }}>
        {hasTelegramLinked ? (
          <>
            <p className="green pb-4">Your Telegram account is linked</p>
            <Button loading={isLoading} onClick={onUnlinkTelegram}>
              Unlink account
            </Button>
          </>
        ) : (
          <div>
            <p className="pb-6 red">Your Telegram account is not linked</p>
            {link && !isExpired ? (
              <>
                <div className="hidden md:block pb-2">
                  <p className="pb-4">
                    Scan the code below to link telegram account (valid{" "}
                    {Math.round(link.expiresInSeconds / 60)} minutes)
                  </p>
                  <QRCodeSVG
                    value={link.url}
                    includeMargin
                    bgColor={"#eeeeee"}
                  />
                </div>
                <a target="_blank" rel="noreferrer" href={link.url}>
                  Click here to link your account
                </a>
              </>
            ) : (
              <Button loading={isLoading} onClick={createLink}>
                {isExpired ? "Link expired - create a new one" : "Create link"}
              </Button>
            )}
          </div>
        )}
      </div>
    </GenericCard>
  );
};

LinkTelegramAccount.propTypes = {
  completed: PropTypes.bool,
};

export default LinkTelegramAccount;
